export default __webpack_public_path__ + "static/media/Live.37dfe760.gif";